<template>
  <v-app>
    <Navbar v-if="$route.name !== 'Login'" />
    <NavDrawer v-if="$route.name !== 'Login'" />

    <v-main class="mx-4 mb-4">
      <v-dialog
        v-model="$store.state.loading"
        persistent
        width="300"
      >
        <v-card
          color="teal"
          dark
        >
          <v-card-text>
            <br>
            Loading
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <router-view></router-view>
    </v-main>

  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import NavDrawer from './components/NavDrawer'

export default {
  name: 'App',

  components: {
    Navbar,
    NavDrawer
  },

  mounted () {
    console.log('VUE_APP_API_URL:', process.env.VUE_APP_API_URL)
    this.$store.dispatch('getAuthUser')
    this.$store.dispatch('getLocations')
    this.$store.dispatch('getIothubs')
    this.$store.dispatch('getLogTags')
  }
}
</script>
